import { T_ProfileHamburgerMenuResponse } from "./ProfileHamburgerMenu.Types";
import { CSApiService } from "../../redux-store/CSApiService";
import {
  Api_CMS_ClaimProcessDocument,
  APi_CMS_ErrorDetails,
  APi_CMS_GetHamburgerMenu,
  APi_CMS_IntegrationVariables,
  API_CMS_No_Holding_New_Product_Cards,
  APi_CMS_NpsFeedBack,
  Api_CMS_Nudge,
  APi_CMS_PageMessages,
  APi_CMS_PageVariables,
  Api_CMS_PromotionalCard,
  API_CMS_Unified_Offer_Marts,
  API_HL_SuccessMessages,
} from "../../utils/ApiEndpoints";
import { T_CmsIntegrationVariablesApiResponse } from "./CmsIntegrationVariable.Types";
import {
  T_CmsFetchUnifiedOfferMart_Response,
  T_CmsFetchNoHoldingNewProductCards_Response,
  T_CmsPageVariablesResponse,
} from "./CmsPageVariable.Types";
import { T_CmsErrorResponse } from "./CmsErrorVariables.Types";
import { T_CmsPageMessageApiResponse } from "./CmsPageMessages.Types";
import { T_CmsNpsFeedback_Response } from "./CmsNpsFeedback.Types";
import {
  T_ClaimProcessDocument_Request,
  T_ClaimProcessDocument_Response,
  T_CmsHlSuccessMessages,
  T_CmsHlSuccessMessagesApiResponse,
} from "./CmsHlSuccessMessages.Types";
import { T_ApiResponse } from "../../globalTypes/GlobalTypes";
import { T_CmsPromotionalCardResponse } from "./CmsPromotinalCard.Types";
import { T_CmsNudgeResponse } from "./CmsSuccessNudge.Types";
export const cmsApi = CSApiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchHamburgerMenu: builder.query<T_ProfileHamburgerMenuResponse, void>({
      query: () => ({
        url: APi_CMS_GetHamburgerMenu,
        method: "POST",
      }),
      providesTags: ["PROFILE_HAMBURGER_MENU_DATA"],
    }),
    FetchIntegrationVariable: builder.query<
      T_CmsIntegrationVariablesApiResponse,
      void
    >({
      query: () => ({
        url: APi_CMS_IntegrationVariables,
        method: "POST",
      }),
      //providesTags: ['CMS_Integration_VARIABLES_DATA'],
    }),

    FetchPageVariable: builder.query<T_CmsPageVariablesResponse, void>({
      query: () => ({
        url: APi_CMS_PageVariables,
        method: "POST",
      }),
      //providesTags: ['CMS_PAGE_VARIABLES_DATA'],
    }),
    FetchErrorVariable: builder.query<T_CmsErrorResponse, void>({
      query: () => ({
        url: APi_CMS_ErrorDetails,
        method: "POST",
      }),
      //providesTags: ['CMS_PAGE_VARIABLES_DATA'],
    }),
    FetchPageMessage: builder.query<T_CmsPageMessageApiResponse, void>({
      query: () => ({
        url: APi_CMS_PageMessages,
        method: "POST",
      }),
      //providesTags: ['CMS_PAGE_VARIABLES_DATA'],
    }),
    FetchNpsFeedback: builder.query<T_CmsNpsFeedback_Response, void>({
      query: () => ({
        url: APi_CMS_NpsFeedBack,
        method: "POST",
      }),
    }),
    FetchHlSuccessMessages: builder.query<
      T_CmsHlSuccessMessagesApiResponse,
      void
    >({
      query: () => ({
        url: API_HL_SuccessMessages,
        method: "POST",
      }),
    }),
    FetchUnifiedOfferMarts: builder.query<
      T_ApiResponse<T_CmsFetchUnifiedOfferMart_Response>,
      void
    >({
      query: () => ({
        url: API_CMS_Unified_Offer_Marts,
        method: "POST",
      }),
    }),
    fetchClaimProcessDocuments: builder.query<
      T_ApiResponse<T_ClaimProcessDocument_Response>,
      T_ClaimProcessDocument_Request
    >({
      query: (payload) => ({
        url: Api_CMS_ClaimProcessDocument,
        method: "POST",
        body: payload,
      }),
    }),
    FetchNoHoldingNewProductCards: builder.query<
      T_ApiResponse<T_CmsFetchNoHoldingNewProductCards_Response>,
      void
    >({
      query: () => ({
        url: API_CMS_No_Holding_New_Product_Cards,
        method: "POST",
      }),
    }),
    fetchPromotionalCard: builder.query<T_CmsPromotionalCardResponse, void>({
      query: (payload) => ({
        url: Api_CMS_PromotionalCard,
        method: "POST",
        body: payload,
      })
    }),
    fetchNudgeData: builder.query<
      T_CmsNudgeResponse,
      void
    >({
      query: (value) => ({
        method: "GET",
        url: Api_CMS_Nudge,
      }),
    }),
  }),
});

export const {
  useLazyFetchHamburgerMenuQuery,
  useLazyFetchIntegrationVariableQuery,
  useLazyFetchPageVariableQuery,
  useLazyFetchErrorVariableQuery,
  useLazyFetchPageMessageQuery,
  useLazyFetchNpsFeedbackQuery,
  useLazyFetchHlSuccessMessagesQuery,
  useLazyFetchUnifiedOfferMartsQuery,
  useLazyFetchClaimProcessDocumentsQuery,
  useLazyFetchNoHoldingNewProductCardsQuery,
  useLazyFetchPromotionalCardQuery,
  useLazyFetchNudgeDataQuery
} = cmsApi;
